import React from 'react'
import util from '../util/util.js'
import moment from 'moment'

require('../css/venuePage.css')

const ArchiveViewWithCustomName = (props) => {
  return (
    <li onClick={props.handleClick} className='video-list-item'>
      <div className="meta">
        <a className="src-link">
          <p className="name">{props.video.custom_name}</p>
          <p className="date">{props.video.date}</p>
          <p className="time">{props.video.time}</p>
          <p className="duration">Duration {props.duration}</p>
        </a>
      </div>
      <div className="thumb">
        <a>
          <div className="thumb-wrapper">
            <div className="play-button">
              <i className="fa fa-play"></i>
            </div>
            <img width="140" height="79"
            className="lazyload video-image-sidebar"
            src={props.video.thumbnailLink} alt={props.video.custom_name}
            aria-label={props.video.custom_name} />

            <div className="image-after"></div>
          </div>
        </a>
      </div>
    </li>
  )
}

const ArchiveView = (props) => {
  return (
    <li onClick={props.handleClick} className='video-list-item'>
      <div className="meta">
        <a className="src-link">
          <p className="date">{props.video.date}</p>
          <p className="time">{props.video.time}</p>
          <p className="duration">Duration: {props.duration}</p>
        </a>
      </div>
      <div className="thumb">
        <a>
          <div className="thumb-wrapper">
            <div className="play-button">
              <i className="fa fa-play"></i>
            </div>
            <img width="140" height="79" className="lazyload video-image-sidebar" src={props.video.thumbnailLink}
            alt={props.video.date} aria-label={props.video.date}/>
            <div className="image-after"></div>
          </div>
        </a>
      </div>
    </li>
  )
}

export default class Archive extends React.Component {
  constructor(props){
    super(props)
    this.state = { external: props.external }
    this.handleClick = this.handleClick.bind(this)
    this.playInPlayer = this.playInPlayer.bind(this)
    this.openVenue = this.openVenue.bind(this)
  }
  playInPlayer(video){
    video.type = 'application/x-mpegurl'
    window.Player.play(video)
    util.scrollTo(document.body, 0, 600)
  }
  openVenue(video){
    let baseUrl = 'https://venue.streamspot.com/';
    if (window.location.hostname.includes('testing') || window.location.hostname.includes('stage') || window.location.hostname.includes('sandbox') || window.location.hostname.includes('localhost')) {
      baseUrl = 'https://testing-venue.streamspot.com/';
    }
    window.open(baseUrl+`video/${video.idHash}`)
  }
  handleClick(){
    return this.state.external ? this.openVenue(this.props.video) : this.playInPlayer(this.props.video)
  }
  render(){
    var duration = moment().startOf('day').seconds(this.props.video.duration).format('H:mm:ss')
    if (!this.props.video.thumbnailLink) {
      this.props.video.thumbnailLink = '//cdn2.streamspot.com/streamspot-od-w-circles-160x90.png'
    }
    if(this.props.video.custom_name){
      return (<ArchiveViewWithCustomName handleClick={this.handleClick} video={this.props.video} duration={duration}/>)
    }else{
      return (<ArchiveView handleClick={this.handleClick} video={this.props.video} duration={duration}/>)
    }
  }
}

Archive.propTypes =  {
  video: React.PropTypes.object.isRequired,
  external: React.PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Archive.jsx